<template>
  <div class="category-form" v-show="isShowForm">
    <FormElement
      :horizontal="true"
      :style="{ 'max-width': '700px', margin: '0 auto' }"
    >
      <fieldset class="k-form-fieldset">
        <div
          v-if="
            kendoForm.visited &&
            kendoForm.errors &&
            kendoForm.errors.VALIDATION_SUMMARY
          "
          class="k-messagebox k-messagebox-error"
        >
          {{ kendoForm.errors.VALIDATION_SUMMARY }}
        </div>

        <div class="wrap-tree-list" :class="{'invalid': invalidOptions.includes('category-parent')}">
          <TreeList
            class="category-form__tree-list"
            :navigatable="true"
            :expand-field="expandField"
            :sub-items-field="subItemsField"
            @expandchange="onExpandChange"
            @selectionchange="onSelectionChange"
            :data-items="processedData"
            :columns="columns"
            :toolbar="'toolbar'"
            :selected-field="selectedField"
            :selected-items="selectedItems"
          >
            <template v-slot:operation="{ props }">
              <td class="k-command-cell k-table-td">
                <div class="cell-control">
                  <button
                    type="button"
                    class="category-form__btn-select"
                    :class="
                      activeCategory === props?.dataItem?.id ? 'active' : ''
                    "
                    @click="handleSelecteCategory($event, props)"
                  >
                    {{ getBtnText }}
                  </button>
                </div>
              </td>
            </template>
          </TreeList>
          <p class="wrap-tree-list__invalid-message" v-if="invalidOptions.includes('category-parent')">
            {{ getMessageByLang('selectParentCategory', 'Выберите родительскую категорию') }}
          </p>
        </div>

        <Field
          :name="'name'"
          :type="'text'"
          :component="'CategoryForm'"
          :label="categoryNameMessage"
          :validator="nameValidator"
        >
          <template v-slot:CategoryForm="{ props }">
            <FormInput
              v-bind="props"
              @change="props.onChange"
              @blur="props.onBlur"
              @focus="props.onFocus"
              :valid="!invalidOptions.includes('name')"
            />
          </template>
        </Field>
        <Field
          :name="'descr'"
          :type="'text'"
          :component="'CategoryForm'"
          :label="categoryDescrMessage"
          :validator="requiredValidator"
        >
          <template v-slot:CategoryForm="{ props }">
            <FormTextArea
              v-bind="props"
              @change="props.onChange"
              @blur="props.onBlur"
              @focus="props.onFocus"
              :valid="!invalidOptions.includes('description')"
            >
            </FormTextArea>
          </template>
        </Field>
        <Field
          :name="'visible'"
          :component="'CategoryForm'"
          :label="visibleMessage"
          class="checkobox-custom-visible"
        >
          <template v-slot:CategoryForm="{ props }">
            <FormCheckbox
              v-bind="props"
              @change="props.onChange"
              @blur="props.onBlur"
              @focus="props.onFocus"
            >
            </FormCheckbox>
          </template>
        </Field>
      </fieldset>
    </FormElement>
  </div>
</template>
<script>
import {
  TreeList,
  mapTree,
  extendDataItem,
} from "@progress/kendo-vue-treelist";
import { Field, FormElement } from "@progress/kendo-vue-form";
import FormInput from "../ProfileComponents/FormInput.vue";
import FormCheckbox from "../ProfileComponents/FormCheckbox.vue";
import FormTextArea from "../ProfileComponents/FormTextArea.vue";
import { provideLocalizationService } from "@progress/kendo-vue-intl";
import { getMessageByLang } from "@/utils/translate.js";
import axios from "axios";

import { requiredValidator, firstNameValidator } from "../../assets/validators";
export default {
  components: {
    Field,
    FormElement,
    FormInput,
    FormCheckbox,
    FormTextArea,
    TreeList,
  },
  inject: {
    kendoForm: { default: {} },
    kendoLocalizationService: { default: null },
  },
  data() {
    return {
      isShowForm: false,
      selectedField: "selected",
      activeCategory: null,
      getMessageByLang: getMessageByLang,
      nameValidator: firstNameValidator,
      requiredValidator: requiredValidator,
      categories: [
        {
          id: 0,
          name: "Корень",
        },
      ],
      parent_id: 0,
      subItemsField: "children",
      expandField: "has_children",
      expanded: [],
      selectedItems: [],
      invalidOptions: [],
    };
  },
  props: {
    defaulValue: {
      required: false,
      default: null,
    },
  },
  computed: {
    columns() {
      return [
        { field: "selected", width: "7%" },
        {
          field: "name",
          title: this.getMessageByLang("categoryName", "categoryName"),
          expandable: true,
        },
      ];
    },

    getBtnText() {
      return this.getMessageByLang("selectText", "Выбрать");
    },

    processedData() {
      let data = this.categories;
      return this.addExpandField(data);
    },

    categoryMessage() {
      return provideLocalizationService(this).toLanguageString(
        "category",
        "Category"
      );
    },
    categoryNameMessage() {
      return provideLocalizationService(this).toLanguageString(
        "categoryName",
        "Category Name"
      );
    },
    categoryDescrMessage() {
      return provideLocalizationService(this).toLanguageString(
        "categoryDescr",
        "Category Description"
      );
    },
    visibleMessage() {
      return provideLocalizationService(this).toLanguageString(
        "visible",
        "Visible"
      );
    },
    cancelMessage() {
      return provideLocalizationService(this).toLanguageString(
        "cancel",
        "Cancel"
      );
    },
    loginMessage() {
      return provideLocalizationService(this).toLanguageString(
        "login",
        "Login"
      );
    },
  },
  methods: {
    showInvalidOptions(list = []) {
      this.invalidOptions = list;
    },

    getParentId() {
      return this.parent_id;
    },

    handleSelecteCategory() {},

    addExpandField(dataTree) {
      const expanded = this.expanded;
      return mapTree(dataTree, this.subItemsField, (item) =>
        extendDataItem(item, this.subItemsField, {
          [this.expandField]: expanded.includes(item.id),
        })
      );
    },

    clear() {
      this.kendoForm.onFormReset();
    },
    onExpandChange(e) {
      this.expanded = e.value
        ? this.expanded.filter((id) => id !== e.dataItem.id)
        : [...this.expanded, e.dataItem.id];

      this.categories = this.selectCategoryById(
        this.categories,
        this.parent_id
      );
    },

    selectCategoryById(categories, parent_id) {
      return categories.map((category) => {
        category.selected = false;
        if (category.id === parent_id) {
          category.selected = true;
        }

        if (category.children && category.children.length > 0) {
          category.children = this.selectCategoryById(
            category.children,
            parent_id
          );
        }

        return category;
      });
    },

    getCategories() {
      var self = this;
      this.isShowForm = false;
      axios
        .get("/api/v1/categories/tree")
        .then((res) => {
          if (res.data) {
            self.categories = self.categories.concat(res.data.data);
          }

          if (
            this.defaulValue &&
            this.defaulValue.parent_id !== null &&
            this.defaulValue.parent_id !== undefined
          ) {
            this.parent_id = this.defaulValue.parent_id;
            this.categories = this.selectCategoryById(
              this.categories,
              this.parent_id
            );
            this.selectedItems = [this.parent_id];
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(() => {
          this.isShowForm = true;
        });
    },

    onSelectionChange(data) {
      this.activeCategory = data?.dataItem?.id;
      this.parent_id = data?.dataItem?.id;
      this.selectedItems = [this.parent_id];

      mapTree(this.processedData, this.subItemsField, (item) => {
        item.selected = false;
        return item;
      });
      this.categories = this.selectCategoryById(
        this.categories,
        data?.dataItem?.id
      );
    },

    getValues() {
      return {
        parent_id: this.parent_id,
      }
    }
  },
  mounted() {
    this.getCategories();
  },
};
</script>
<style scoped>
.k-form-buttons {
  justify-content: center;
}
</style>

<style lang="scss">
.checkobox-custom-visible label {
  padding: 0 !important;
}

.category-form {
  &__tree-list {
    height: 100%;
    max-height: 250px;
    overflow: auto;

    & .k-column-title input {
      display: none !important;
    }
  }

  &__btn-select {
    padding: 0.3rem 0.5rem;
    border: 1px solid rgb(245, 245, 245);
    background: rgb(245, 245, 245);
    color: #000;
    cursor: pointer;

    &:hover,
    &:active,
    &.active {
      border: 1px solid rgb(255, 99, 88);
      color: #fff;
      background: rgb(255, 99, 88);
    }
  }
}
</style>